<div class="tx-center tx-black pt-2-0" mat-dialog-content>
    <h5 data-testid="message-component-title">{{ config.title }}</h5>
    @if (config.text){
        <span>{{ config.text }}</span>
    }
</div>
<div class="flex j-center w-100p" mat-dialog-actions>
    @if (config.showSecondaryButton) {
        <button class="button-reset flex-1" [mat-dialog-close]="false" mat-stroked-button color="basic">
            {{ config.secondaryText }}
        </button>
    }

    <button class="flex-1" [mat-dialog-close]="true" mat-flat-button color="primary" data-testid="message-component-primary-button">
        {{ config.primaryText }}
    </button>
</div>
